import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { userContext } from '../../../contexts/userContext'
import cookiesToObject from '../../../utils/cookiesHandler'
import PermissionsLoad from '../PermissionsLoad'

function PrivateRoute() {
  const user = React.useContext(userContext)
  const loginPath = '/login'

  // determine if authorized, from context or however you're doing it

  /**
   *
   * @param {object} info
   */
  const isAuthorized = (info) => {
    let hasPermission = true
    if (info) {
      ;['email', 'id'].forEach((key) => {
        if (!Object.keys(info).includes(key)) {
          hasPermission = false
        }
      })
    } else {
      hasPermission = false
    }
    return hasPermission
  }

  const userInfo = cookiesToObject(document.cookie)
  React.useEffect(() => {
    if (userInfo) {
      user.dispatch({ type: 'ADD_USER_COMPANY', payload: userInfo })
    }
  }, [])

  
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  return isAuthorized(userInfo) ? <PermissionsLoad><Outlet /></PermissionsLoad> : <Navigate to={loginPath} />
}

export default PrivateRoute
